import { useEffect } from "react";

export const DEFAULT_TITLE = "Quantum Boas | High-End Boa Constrictors & Genetics";
export const DEFAULT_DESC = "Purpose-driven boa constrictor breeding: documented genetics, intentional phenotype selection and multi-generation project journals from Quantum Boas.";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const setNoindex = () => upsertMeta("name", "robots", "noindex, follow");
export const clearNoindex = () => {
  const el = document.head.querySelector('meta[name="robots"]');
  if (el) el.remove();
};

// Sets document.title + meta description + Open Graph tags for the current page.
// Also clears any noindex left behind by a not-found view.
export function useSeo({ title, description, image }) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    clearNoindex();
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", title || DEFAULT_TITLE);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", "website");
    if (image) {
      const origin = process.env.REACT_APP_SITE_URL || window.location.origin;
      upsertMeta("property", "og:image", image.startsWith("/") ? origin + image : image);
    }
  }, [title, description, image]);
}
